export default function asHTML<E extends HTMLElement = HTMLElement>(
  strings: TemplateStringsArray,
  ...exprs: any[]
): E {
  const el = document.createElement("template");
  const str = String.raw({ raw: strings }, ...exprs).trim();
  el.innerHTML = str;
  const nNodes = el.content.childNodes.length;
  if (nNodes !== 1) {
    throw new Error(
      `html parameter must represent a single node; got ${nNodes}. ` +
        "Note that leading or trailing spaces around an element in your " +
        'HTML, like " <img/> ", get parsed as text nodes neighbouring ' +
        "the element; call .trim() on your input to avoid this.",
    );
  }
  console.log(el);
  return el.content.firstChild!.cloneNode(true) as E;
}
